import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyCiFhEK81KAaFHLDPA-Quwc3BQZgC9G9ZM',
    appId: '1:367417745620:web:467255f2a263049db45b41',
    authDomain: 'parkstory-87690.firebaseapp.com',
    measurementId: 'G-RS98QQSZMV',
    messagingSenderId: '367417745620',
    projectId: 'parkstory-87690',
    storageBucket: 'parkstory-87690.appspot.com',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth(firebaseApp);
const providers = {
    apple: new firebase.auth.OAuthProvider('apple.com'),
    facebook: new firebase.auth.FacebookAuthProvider(),
    google: new firebase.auth.GoogleAuthProvider(),
};

export { auth, providers };
